import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { map, withLatestFrom } from 'rxjs/operators';
import { GetUserSuccess } from '../../user/action-creators';
import { GET_USER_SUCCESS } from '../../user/actions';
import { rudderIdentify } from '@webapp/utils/rudderstack/init';
import AppState from '@webapp/store/state';
import { signedInEvent, signedUpEvent } from '@webapp/utils/rudderstack/events';
import {
  getLocalStorageItem,
  removeLocalStorageItem,
} from '@webapp/utils/localstorage';
import { NoOp } from '@webapp/store/ui/action-creators';
import { UserConfigured } from '@webapp/store/auth/action-creators';
import { setBeaconIdentity } from '../../../utils/helpscout/indentify';

export const identifyUserEpic = (
  action$: Observable<GetUserSuccess>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType(GET_USER_SUCCESS),
    withLatestFrom(state$),
    map(([action, state]) => {
      if (state.auth.configured) {
        return new NoOp();
      }
      if (window.analytics) {
        window.analytics.identify(action.user.id as string, {
          name: action.user.fullName,
          email: action.user.email,
          phone: action.user.telephone,
          createdAt: action.user.created_at
            ? action.user.created_at.toISOString()
            : undefined,
          address: {
            country: action.user.country?.name,
            state: action.user.address?.state,
            city: action.user.address?.city,
            street: action.user.address?.address,
            postalCode: action.user.address?.postalCode,
          },
        });
      }
      rudderIdentify(action.user.id as string, {
        name: action.user.fullName,
        email: action.user.email,
        phone: action.user.telephone,
        createdAt: action.user.created_at
          ? action.user.created_at.toISOString()
          : undefined,
        address: {
          country: action.user.country?.name,
          state: action.user.address?.state,
          city: action.user.address?.city,
          street: action.user.address?.address,
          postalCode: action.user.address?.postalCode,
        },
      });

      setBeaconIdentity({
        artistName: state.artist?.active?.name ?? '',
        email: action.user.email ?? '',
        doj: action.user.created_at?.toISOString() ?? '',
        userId: action.user.id ?? '',
        name: action.user.fullName ?? '',
      });

      if (state.auth.newUser) {
        const provider = getLocalStorageItem('provider');
        signedUpEvent({
          email: action.user.email,
          phone_number: action.user.telephone,
          signup_source: provider,
        }).then(() => {
          removeLocalStorageItem('provider');
        });
      }

      if (state.auth.justLoggedIn) {
        const provider = getLocalStorageItem('provider');
        signedInEvent({
          email: action.user.email,
          phone_number: action.user.telephone,
          signin_source: provider,
        }).then(() => {
          removeLocalStorageItem('provider');
        });
      }
      return new UserConfigured();
    })
  );
